export default "__VITE_ASSET__D2NgLkb1__"